module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.active) ? _c('div', {
    staticClass: "event-tab"
  }, [_c('div', {
    staticClass: "info wrapper dark fs-small bg-lightest px-4"
  }, [(_vm.event.status == -1) ? _c('div', {
    staticClass: "col-sm-12 text-center mb-3"
  }, [_c('div', {
    staticClass: "color-6 fs-large"
  }, [_vm._v("Activity Canceled")]), _vm._v(" "), (_vm.event.statusMessage) ? _c('div', {
    staticClass: "darker"
  }, [_vm._v(_vm._s(_vm.event.statusMessage))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "detailLabel bold"
  }, [_vm._v("\n                        Departure:\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "darker bold p-0"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("moment")(_vm.event.start, 'YYYY.MM.DD')) + " | " + _vm._s(_vm._f("moment")(_vm.event.start, 'HH:mm')) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex mt-2"
  }, [_c('div', {
    staticClass: "detailLabel bold"
  }, [_vm._v("\n                        Duration:\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "darker bold p-0"
  }, [_vm._v("\n                        " + _vm._s(_vm.hourToDuration(this.event.duration)) + "\n                    ")])]), _vm._v(" "), (_vm.event.product && _vm.event.product.transport && _vm.event.product.transport.length > 0) ? _c('div', {
    staticClass: "d-flex mt-2"
  }, [_c('div', {
    staticClass: "detailLabel bold"
  }, [_vm._v("\n                        Transport:\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "darker bold p-0"
  }, [_vm._v("\n                        " + _vm._s(_vm.event.product.transport.name) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.event.location) ? _c('div', {
    staticClass: "d-flex mt-2"
  }, [_c('div', {
    staticClass: "detailLabel bold"
  }, [_vm._v("\n                        Location:\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "darker bold p-0"
  }, [_vm._v("\n                        " + _vm._s(_vm.event.location) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex mt-2"
  }, [_c('div', {
    staticClass: "detailLabel bold"
  }, [_vm._v("\n                        Channel:\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "darker bold p-0 d-flex flex-row"
  }, [_c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.channelToolTips.agent),
      expression: "channelToolTips.agent"
    }],
    staticClass: "d-flex align-items-center"
  }, [_c('span', {
    staticClass: "channelCircle mr-1 radius-circle bg-medium",
    class: {
      'bg-color-4': _vm.salesChannelsStatus.agentCustom, 'bg-color-3': _vm.salesChannelsStatus.agent, 'bg-dark': !_vm.salesChannelsStatus.agent
    }
  }), _vm._v(" "), _c('span', [_vm._v("Agents")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.channelToolTips.widget),
      expression: "channelToolTips.widget"
    }],
    staticClass: "d-flex align-items-center ml-2"
  }, [_c('span', {
    staticClass: "channelCircle mr-1 radius-circle bg-medium",
    class: {
      'bg-color-3': _vm.salesChannelsStatus.widget, 'bg-dark': !_vm.salesChannelsStatus.widget
    }
  }), _vm._v(" "), _c('span', [_vm._v("Widget")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.channelToolTips.me),
      expression: "channelToolTips.me"
    }],
    staticClass: "d-flex align-items-center ml-2"
  }, [_c('span', {
    staticClass: "channelCircle mr-1 radius-circle bg-medium",
    class: {
      'bg-color-3': _vm.salesChannelsStatus.me, 'bg-dark': !_vm.salesChannelsStatus.me
    }
  }), _vm._v(" "), _c('span', [_vm._v("Me")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper d-flex"
  }, [_c('div', {
    staticClass: "w-100 px-3 bg-lighter radius-normal border-medium py-2 mr-1 d-flex flex-column maxWidth50"
  }, [_c('div', {
    staticClass: "border-bottom-light"
  }, [_c('div', {
    staticClass: "text-uppercase fs-smallest dark"
  }, [_vm._v("Available")]), _vm._v(" "), (_vm.event.availabilityType == 1) ? _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Unlimited'),
      expression: "'Unlimited'"
    }],
    staticClass: "fs-giant"
  }, [_c('i', {
    staticClass: "fas fa-infinity"
  })]) : _c('div', {
    staticClass: "fs-giant"
  }, [_vm._v(_vm._s(_vm.event.quantityAvailable))]), _vm._v(" "), _c('div', {
    staticClass: " mb-2"
  }, [(_vm.totalReserved) ? _c('span', {
    staticClass: "lightest bg-color-1 radius-normal fs-smaller px-1 bold"
  }, [_vm._v(_vm._s(_vm.totalReserved) + " booking now")]) : _c('span', [_vm._v(" ")])])]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-light mb-2 flexGrow1 py-1"
  }, [(_vm.event.eventResources.length < 1) ? _c('div', {
    staticClass: "light h-100 d-flex align-items-center justify-content-center"
  }, [_vm._v("No resources")]) : _vm._l((_vm.event.eventResources), function(resource) {
    return _c('div', {
      staticClass: "d-flex justify-content-between fs-smaller"
    }, [_c('div', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: (resource.name),
        expression: "resource.name"
      }],
      staticClass: "dark elipsis mr-2 cursor-default text-uppercase bold"
    }, [_vm._v(_vm._s(resource.name))]), _vm._v(" "), (_vm.event.availabilityType == 2) ? _c('div', {
      staticClass: "d-flex"
    }, [_c('span', {
      staticClass: "darker bold"
    }, [_vm._v(_vm._s(resource.capacityAvailable))]), _vm._v(" "), _c('span', {
      staticClass: "dark bold"
    }, [_vm._v("/" + _vm._s(resource.maxSeats))])]) : _vm._e()])
  })], 2), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "text-uppercase fs-smaller dark bold"
  }, [_vm._v("\n                            Booked\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "bold"
  }, [_vm._v("\n                            " + _vm._s(_vm.event.quantityBooked) + "\n                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "w-100 px-3 bg-lighter radius-normal border-medium py-2 ml-1 d-flex flex-column maxWidth50"
  }, [_c('div', {
    staticClass: "border-bottom-light"
  }, [_c('div', {
    staticClass: "text-uppercase fs-smallest dark"
  }, [_vm._v("Check-ins")]), _vm._v(" "), _c('div', {
    staticClass: "fs-giant"
  }, [_vm._v(_vm._s(_vm.event.totalPAXCheckedIn) + "/" + _vm._s(_vm.event.quantityBooked))]), _vm._v(" "), _c('div', {
    staticClass: "bold mb-2",
    class: {
      'color-6': _vm.event.totalPAXMissing > 0, 'dark': _vm.event.totalPAXMissing == 0
    }
  }, [_vm._v(_vm._s(_vm.event.totalPAXMissing) + " missing")])]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-light mb-2 flexGrow1 py-1"
  }, _vm._l((_vm.event.eventOccupancyList), function(clientType) {
    return (_vm.isToShowThisClientType(clientType)) ? _c('div', {
      staticClass: "d-flex justify-content-between"
    }, [_c('div', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: (clientType.audienceType ? clientType.audienceTypeDescription : 'Order'),
        expression: "clientType.audienceType ? clientType.audienceTypeDescription : 'Order'"
      }],
      staticClass: "dark elipsis flexGrow1 mr-2 text-uppercase bold fs-smaller"
    }, [_vm._v("\n                                " + _vm._s(clientType.audienceType ? clientType.audienceTypeDescription : 'Order') + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "fs-smaller"
    }, [_c('span', {
      staticClass: "darker bold"
    }, [_vm._v(_vm._s(clientType.quantity))])])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "text-uppercase fs-smaller dark bold"
  }, [_vm._v("\n                            No-Shows\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "bold"
  }, [_vm._v("\n                            " + _vm._s(_vm.event.totalPAXNoShow) + "\n                        ")])])])])]), _vm._v(" "), (_vm.event.availabilityType == 2 && _vm.event.shareType == 1) ? _c('div', {
    staticClass: "wrapper mt-0 pt-0 d-flex"
  }, [_c('img', {
    staticClass: "mr-1 p-1",
    style: ({
      'background-color': _vm.eventColor.codeSecundary
    }),
    attrs: {
      "src": "/static/images/event/shared_product_icon_black.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fs-normal"
  }, [_vm._v("Resource are shared with more activities")])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-625316d0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-625316d0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/EventDetails.vue
// module id = 1673
// module chunks = 0